import {lazy, FC, Suspense, useEffect, useState} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import DevelopmentAcademyPage from '../modules/developmentacademy/DevelopmentAcademyPage'
import { Appointments } from '../modules/appointments/appointments-list/core/_models';

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const UserClaimPage = lazy(() => import('../modules/userclaim/UserClaimPage'))
  const UserLoginPage = lazy(() => import('../modules/userlogin/UserLoginPage'))
  const UserRolePage = lazy(() => import('../modules/userrole/UserRolePage'))
  const RoleClaimPage = lazy(() => import('../modules/roleclaim/RoleClaimPage'))
  const RolePage = lazy(() => import('../modules/role/RolePage'))

  const PersonTypePage = lazy(() => import('../modules/persontype/PersonTypePage'))

  const PersonPage = lazy(() => import('../modules/person/PersonPage'))

  const CityPage = lazy(() => import('../modules/city/CityPage'))

  const CountryPage = lazy(() => import('../modules/country/CountryPage'))

  const EmployeePage = lazy(() => import('../modules/employee/EmployeePage'))

  const EmployeeTypePage = lazy(() => import('../modules/employeetype/EmployeeTypePage'))

  const GenderPage = lazy(() => import('../modules/gender/GenderPage'))

  const InstitutionPage = lazy(() => import('../modules/institution/InstitutionPage'))

  const LanguagePage = lazy(() => import('../modules/language/LanguagePage'))

  const PlacePage = lazy(() => import('../modules/place/PlacePage'))

  const WorkingStatuePage = lazy(() => import('../modules/workingstatue/WorkingStatuePage'))

  const UnitTypePage = lazy(() => import('../modules/unittype/UnitTypePage'))

  const UnitPage = lazy(() => import('../modules/unit/UnitPage'))

  const ClassPage = lazy(() => import('../modules/class/ClassPage'))

  const TermPage = lazy(() => import('../modules/term/TermPage'))

  const SubinstitutionPage = lazy(() => import('../modules/subinstitution/SubinstitutionPage'))

  const StudyTypePage = lazy(() => import('../modules/studytype/StudyTypePage'))

  const StudyEventTypePage = lazy(() => import('../modules/studyeventtype/StudyEventTypePage'))

  const SubinstitutionTypePage = lazy(
    () => import('../modules/subinstitutiontype/SubinstitutionTypePage')
  )

  const LessonPage = lazy(() => import('../modules/lesson/LessonPage'))

  const StudyPage = lazy(() => import('../modules/study/StudyPage'))

  const DashboardAppointmentsPage = lazy(() => import('../modules/appointments/DashboardAppointmentsPage'))

  const AppointmentsPage = lazy(() => import('../modules/appointments/AppointmentsPage'))

  const CustomerPage = lazy(() => import('../modules/customer/CustomerPage'))

  const SubinstitutionSubinstitutionTypePage = lazy(
    () => import('../modules/subinstitutionsubinstitutiontype/SubinstitutionSubinstitutionTypePage')
  )

  const SubinstitutionTypeBranchPage = lazy(
    () => import('../modules/subinstitutiontypebranch/SubinstitutionTypeBranchPage')
  )

  const EmployeeLessonPage = lazy(() => import('../modules/employeelesson/EmployeeLessonPage'))

  const AnnouncementPage = lazy(() => import('../modules/announcement/AnnouncementPage'))

  const GuidancePage = lazy(() => import('../modules/guidance/GuidancePage'))

  const SubjectPage = lazy(() => import('../modules/subject/SubjectPage'))

  const SubinstitutionLessonPage = lazy(
    () => import('../modules/subinstitutionlesson/SubinstitutionLessonPage')
  )

  const SurveyTypePage = lazy(() => import('../modules/surveytype/SurveyTypePage'))

  const SurveyResultPage = lazy(() => import('../modules/surveyresult/SurveyResultPage'))

  const SurveyPage = lazy(() => import('../modules/survey/SurveyPage'))

  const SurveyQuestionPage = lazy(() => import('../modules/surveyquestion/SurveyQuestionPage'))

  const CurriculumSubjectPage = lazy(
    () => import('../modules/curriculumsubject/CurriculumSubjectPage')
  )

  const HelpPage = lazy(() => import('../modules/help/HelpPage'))

  const AcademicYearPage = lazy(() => import('../modules/academicyear/AcademicYearPage'))

  const MessageTypePage = lazy(() => import('../modules/messagetype/MessageTypePage'))

  const TicketTypePage = lazy(() => import('../modules/tickettype/TicketTypePage'))

  const TicketStatuPage = lazy(() => import('../modules/ticketstatu/TicketStatuPage'))

  const PriorityColoringTypePage = lazy(
    () => import('../modules/prioritycoloringtype/PriorityColoringTypePage')
  )

  const TicketPage = lazy(() => import('../modules/ticket/TicketPage'))

  const MessagePage = lazy(() => import('../modules/message/MessagePage'))

  const CustomerAnnouncementPage = lazy(
    () => import('../modules/announcement/CustomerAnnouncementPage')
  )
  const ReportAnnouncementPage = lazy(
    () => import('../modules/announcement/ReportAnnouncementPage')
  )

  const DashboardStudyPage = lazy(() => import('../modules/study/DashboardStudyPage'))


  const DashboardAnnouncementPage = lazy(
    () => import('../modules/announcement/DashboardAnnouncementPage')
  )

  const DashboardEmployeePage = lazy(() => import('../modules/employee/DashboardEmployeePage'))

  const DashboardCustomerPage = lazy(() => import('../modules/customer/DashboardCustomerPage'))

  const CustomerInfoPage = lazy(() => import('../modules/customer/CustomerInfoPage'))

  const DashboardSurveyPage = lazy(() => import('../modules/survey/DashboardSurveyPage'))

  const DashboardGuidancePage = lazy(() => import('../modules/guidance/DashboardGuidancePage'))

  const DashboardUserRolePage = lazy(() => import('../modules/userrole/DashboardUserRolePage'))

  const DashboardSubinstitutionPage = lazy(
    () => import('../modules/subinstitution/DashboardSubinstitutionPage')
  )

  const DashboardMessagePage = lazy(() => import('../modules/message/DashboardMessagePage'))

  const DashboardTicketPage = lazy(() => import('../modules/ticket/DashboardTicketPage'))

  const DashboardCurriculumPage = lazy(
    () => import('../modules/curriculum/DashboardCurriculumPage')
  )

  const CurriculumExamPage = lazy(() => import('../modules/curriculumexam/CurriculumExamPage'))

  const CurriculumQuestionTrackingPage = lazy(
    () => import('../modules/curriculumquestiontracking/CurriculumQuestionTrackingPage')
  )

  const CurriculumToDoListPage = lazy(
    () => import('../modules/curriculumtodolist/CurriculumToDoListPage')
  )

  const CurriculumAssignmentTrackingPage = lazy(
    () => import('../modules/curriculumassignmenttracking/CurriculumAssignmentTrackingPage')
  )

  const CurriculumPage = lazy(() => import('../modules/curriculum/CurriculumPage'))

  const CurrencyPage = lazy(() => import('../modules/currency/CurrencyPage'))

  const PricingPage = lazy(() => import('../modules/pricing/PricingPage'))

  const SalePage = lazy(() => import('../modules/sale/SalePage'))

  const SellerPage = lazy(() => import('../modules/seller/SellerPage'))

  const OfferStatusPage = lazy(() => import('../modules/offerstatus/OfferStatuPage'))

  const OfferTypePage = lazy(() => import('../modules/offertype/OfferTypePage'))

  const OfferPage = lazy(() => import('../modules/offer/OfferPage'))

  const FilePage = lazy(() => import('../modules/file/FilePage'))

  const DashboardFilePage = lazy(() => import('../modules/file/DashboardFilePage'))

  const LibraryFilePage = lazy(() => import('../modules/file/LibraryFilePage'))

  const FileGalleryPage = lazy(() => import('../modules/file/FileGalleryPage'))

  const FileSharePage = lazy(() => import('../modules/fileshare/FileSharePage'))

  const FileTypePage = lazy(() => import('../modules/filetype/FileTypePage'))

  const GalleryPage = lazy(() => import('../modules/gallery/GalleryPage'))

  const CourseSkillPage = lazy(() => import('../modules/courseskill/CourseSkillPage'))

  const CourseResultPage = lazy(() => import('../modules/courseresult/CourseResultPage'))

  const CourseFinishedPage = lazy(() => import('../modules/coursefinished/CourseFinishedPage'))

  const CourseResultTypePage = lazy(
    () => import('../modules/courseresulttype/CourseResultTypePage')
  )

  const CoursePage = lazy(() => import('../modules/course/CoursePage'))

  const CourseTypePage = lazy(() => import('../modules/coursetype/CourseTypePage'))

  const CourseLevelPage = lazy(() => import('../modules/courselevel/CourseLevelPage'))

  const ProficiencyTestPage = lazy(() => import('../modules/proficiencytest/ProficiencyTestPage'))

  const ModulePage = lazy(() => import('../modules/module/ModulePage'))

  const PagePage = lazy(() => import('../modules/page/PagePage'))

  const SettingPage = lazy(() => import('../modules/setting/SettingPage'))

  const ClaimValuePage = lazy(() => import('../modules/claimvalue/ClaimValuePage'))

  const ModuleInstitutionPage = lazy(
    () => import('../modules/moduleinstitution/ModuleInstitutionPage')
  )

  const LogsPage = lazy(() => import('../modules/logs/LogPage'))

  const CustomerAcademicYearPage = lazy(
    () => import('../modules/customeracademicyear/CustomerAcademicYearPage')
  )

  const PersonAcademicYearPage = lazy(
    () => import('../modules/personacademicyear/PersonAcademicYearPage')
  )

  const CourseH5PPage = lazy(() => import('../modules/course/CourseH5PPage'))
  const CourseSkillQuestionPage = lazy(
    () => import('../modules/courseskillquestion/CourseSkillQuestionPage')
  )

  const FinishCoursePage = lazy(() => import('../modules/course/FinishCoursePage'))
  const TakeCoursePage = lazy(() => import('../modules/course/TakeCoursePage'))
  const CourseSkillFeedbackPage = lazy(
    () => import('../modules/courseskillfeedback/CourseSkillFeedbackPage')
  )

  const CourseResultCriteriaPage = lazy(
    () => import('../modules/courseresultcriteria/CourseResultCriterionPage')
  )

  const CourseSchedulePage = lazy(() => import('../modules/courseschedule/CourseSchedulePage'))

  const PublishingOptionPage = lazy(
    () => import('../modules/publishingoption/PublishingOptionPage')
  )

  const CourseRolePage = lazy(() => import('../modules/courserole/CourseRolePage'))

  const GuidanceTypePage = lazy(() => import('../modules/guidancetype/GuidanceTypePage'))

  const GuidanceSubTypePage = lazy(() => import('../modules/guidancesubtype/GuidanceSubTypePage'))

  const GuidanceResultTypePage = lazy(
    () => import('../modules/guidanceresulttype/GuidanceResultTypePage')
  )

  const FileAreaPage = lazy(() => import('../modules/filearea/FileAreaPage'))

  const GuidanceReportPage = lazy(() => import('../modules/guidancereport/GuidanceReportPage'))

  const FileReportPage = lazy(() => import('../modules/filereport/FileReportPage'))

  const FileViewPage = lazy(() => import('../modules/fileview/FileViewPage'))

  const EmployeeUnitPage = lazy(() => import('../modules/employeeunit/EmployeeUnitPage'))

  const GuidanceInfoPage = lazy(() => import('../modules/guidance/GuidanceInfoPage'))

  const CurriculumTypePage = lazy(() => import('../modules/curriculumtype/CurriculumTypePage'))

  const ActivityPage = lazy(() => import('../modules/activity/ActivityPage'))
  const DevelopmentAcademyPage = lazy(() => import('../modules/developmentacademy/DevelopmentAcademyPage'))

  // zg-generateBlock(((zg-pagedefinition)))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/accounts/profile/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/users/user/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/users/role/*'
          element={
            <SuspensedView>
              <RolePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/users/roleclaim/*'
          element={
            <SuspensedView>
              <RoleClaimPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/users/userclaim/*'
          element={
            <SuspensedView>
              <UserClaimPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/users/userlogin/*'
          element={
            <SuspensedView>
              <UserLoginPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/users/userrole/*'
          element={
            <SuspensedView>
              <UserRolePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/institutions/persontype/*'
          element={
            <SuspensedView>
              <PersonTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/customers/person/*'
          element={
            <SuspensedView>
              <PersonPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/countries/city/*'
          element={
            <SuspensedView>
              <CityPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/countries/country/*'
          element={
            <SuspensedView>
              <CountryPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/employees/employee/*'
          element={
            <SuspensedView>
              <EmployeePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/employees/employeetype/*'
          element={
            <SuspensedView>
              <EmployeeTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/institutions/gender/*'
          element={
            <SuspensedView>
              <GenderPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/institutions/institution/*'
          element={
            <SuspensedView>
              <InstitutionPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/countries/language/*'
          element={
            <SuspensedView>
              <LanguagePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/place/*'
          element={
            <SuspensedView>
              <PlacePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/employees/workingstatue/*'
          element={
            <SuspensedView>
              <WorkingStatuePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/employees/unittype/*'
          element={
            <SuspensedView>
              <UnitTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/employees/unit/*'
          element={
            <SuspensedView>
              <UnitPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/class/*'
          element={
            <SuspensedView>
              <ClassPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/term/*'
          element={
            <SuspensedView>
              <TermPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/subinstitution/*'
          element={
            <SuspensedView>
              <SubinstitutionPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/studies/studytype/*'
          element={
            <SuspensedView>
              <StudyTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/studies/studyeventtype/*'
          element={
            <SuspensedView>
              <StudyEventTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/studies/prioritycoloringtype/*'
          element={
            <SuspensedView>
              <PriorityColoringTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/subinstitutiontype/*'
          element={
            <SuspensedView>
              <SubinstitutionTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/lesson/*'
          element={
            <SuspensedView>
              <LessonPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/studies/study/*'
          element={
            <SuspensedView>
              <StudyPage />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/appointments/appointments/*'
          element={
            <SuspensedView>
              <AppointmentsPage />
            </SuspensedView>
          }
        /> 
        
          <Route
          path='crafted/appointments/dashboardappointments/*'
          element={
            <SuspensedView>
              <DashboardAppointmentsPage />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/customers/customer/*'
          element={
            <SuspensedView>
              <CustomerPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/subinstitutionsubinstitutiontype/*'
          element={
            <SuspensedView>
              <SubinstitutionSubinstitutionTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/subinstitutiontypebranch/*'
          element={
            <SuspensedView>
              <SubinstitutionTypeBranchPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/employees/employeelesson/*'
          element={
            <SuspensedView>
              <EmployeeLessonPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/announcements/announcement/*'
          element={
            <SuspensedView>
              <AnnouncementPage />
            </SuspensedView>
          }
        />
        <Route
          path={'crafted/guidances0/guidance/*'}
          element={
            <SuspensedView>
              <GuidancePage />
            </SuspensedView>
          }
        />
        <Route
          path={'crafted/guidances1/guidance/*'}
          element={
            <SuspensedView>
              <GuidancePage />
            </SuspensedView>
          }
        />
        <Route
          path={'crafted/guidances2/guidance/*'}
          element={
            <SuspensedView>
              <GuidancePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/subject/*'
          element={
            <SuspensedView>
              <SubjectPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/curricula/subinstitutionlesson/*'
          element={
            <SuspensedView>
              <SubinstitutionLessonPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/surveys/surveytype/*'
          element={
            <SuspensedView>
              <SurveyTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/surveys/surveyresult/*'
          element={
            <SuspensedView>
              <SurveyResultPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/surveys/survey/*'
          element={
            <SuspensedView>
              <SurveyPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/surveys/surveyquestion/*'
          element={
            <SuspensedView>
              <SurveyQuestionPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/curricula/curriculum/*'
          element={
            <SuspensedView>
              <CurriculumPage />
            </SuspensedView>
          }
        />
        <Route
          path='/crafted/curricula/curriculumexam/*'
          element={
            <SuspensedView>
              <CurriculumExamPage />
            </SuspensedView>
          }
        />
        <Route
          path='/crafted/curricula/curriculumquestiontracking/*'
          element={
            <SuspensedView>
              <CurriculumQuestionTrackingPage />
            </SuspensedView>
          }
        />
        <Route
          path='/crafted/curricula/curriculumassignmenttracking/*'
          element={
            <SuspensedView>
              <CurriculumAssignmentTrackingPage />
            </SuspensedView>
          }
        />
        <Route
          path='/crafted/curricula/curriculumtodolist/*'
          element={
            <SuspensedView>
              <CurriculumToDoListPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/curricula/curriculumsubject/*'
          element={
            <SuspensedView>
              <CurriculumSubjectPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/developmentacademy/developmentacademy/*'
          element={
            <SuspensedView>
              <DevelopmentAcademyPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/helps/help/*'
          element={
            <SuspensedView>
              <HelpPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/academicyear/*'
          element={
            <SuspensedView>
              <AcademicYearPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/messages/messagetype/*'
          element={
            <SuspensedView>
              <MessageTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/tickets/tickettype/*'
          element={
            <SuspensedView>
              <TicketTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/tickets/ticketstatu/*'
          element={
            <SuspensedView>
              <TicketStatuPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/tickets/ticket/*'
          element={
            <SuspensedView>
              <TicketPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/messages/message/*'
          element={
            <SuspensedView>
              <MessagePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/announcements/customerannouncement/*'
          element={
            <SuspensedView>
              <CustomerAnnouncementPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/announcements/reportannouncement/*'
          element={
            <SuspensedView>
              <ReportAnnouncementPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/studies/dashboardstudy/*'
          element={
            <SuspensedView>
              <DashboardStudyPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/announcements/dashboardannouncement/*'
          element={
            <SuspensedView>
              <DashboardAnnouncementPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/employees/dashboardemployee/*'
          element={
            <SuspensedView>
              <DashboardEmployeePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/customers/dashboardcustomer/*'
          element={
            <SuspensedView>
              <DashboardCustomerPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/customers/customerinfo/*'
          element={
            <SuspensedView>
              <CustomerInfoPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/surveys/dashboardsurvey/*'
          element={
            <SuspensedView>
              <DashboardSurveyPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/guidances/dashboardguidance/*'
          element={
            <SuspensedView>
              <DashboardGuidancePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/users/dashboarduserrole/*'
          element={
            <SuspensedView>
              <DashboardUserRolePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/subinstitutions/dashboardsubinstitution/*'
          element={
            <SuspensedView>
              <DashboardSubinstitutionPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/messages/dashboardmessage/*'
          element={
            <SuspensedView>
              <DashboardMessagePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/tickets/dashboardticket/*'
          element={
            <SuspensedView>
              <DashboardTicketPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/curricula/dashboardcurriculum/*'
          element={
            <SuspensedView>
              <DashboardCurriculumPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/sales/currency/*'
          element={
            <SuspensedView>
              <CurrencyPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/sales/pricing/*'
          element={
            <SuspensedView>
              <PricingPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/sales/sale/*'
          element={
            <SuspensedView>
              <SalePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/sales/seller/*'
          element={
            <SuspensedView>
              <SellerPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/sales/offerstatus/*'
          element={
            <SuspensedView>
              <OfferStatusPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/sales/offertype/*'
          element={
            <SuspensedView>
              <OfferTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/sales/offer/*'
          element={
            <SuspensedView>
              <OfferPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/accounts/filetype/*'
          element={
            <SuspensedView>
              <FileTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/accounts/fileshare/*'
          element={
            <SuspensedView>
              <FileSharePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/galleries/gallery/*'
          element={
            <SuspensedView>
              <GalleryPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/accounts/file/*'
          element={
            <SuspensedView>
              <FilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/files/file/*'
          element={
            <SuspensedView>
              <LibraryFilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/files/dashboardfile/*'
          element={
            <SuspensedView>
              <DashboardFilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/modules/module/*'
          element={
            <SuspensedView>
              <ModulePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/modules/page/*'
          element={
            <SuspensedView>
              <PagePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/settings/setting/*'
          element={
            <SuspensedView>
              <SettingPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/modules/claimvalue/*'
          element={
            <SuspensedView>
              <ClaimValuePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/modules/moduleinstitution/*'
          element={
            <SuspensedView>
              <ModuleInstitutionPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/modules/logs/*'
          element={
            <SuspensedView>
              <LogsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/customers/customeracademicyear/*'
          element={
            <SuspensedView>
              <CustomerAcademicYearPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/customers/personacademicyear/*'
          element={
            <SuspensedView>
              <PersonAcademicYearPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/course/*'
          element={
            <SuspensedView>
              <CoursePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/course/*'
          element={
            <SuspensedView>
              <CoursePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/interactivecourse/*'
          element={
            <SuspensedView>
              <CourseH5PPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/takecourse/*'
          element={
            <SuspensedView>
              <TakeCoursePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/finishcourse/*'
          element={
            <SuspensedView>
              <FinishCoursePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/coursetype/*'
          element={
            <SuspensedView>
              <CourseTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/courselevel/*'
          element={
            <SuspensedView>
              <CourseLevelPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/proficiencytest/*'
          element={
            <SuspensedView>
              <ProficiencyTestPage />
            </SuspensedView>
          }
        />{' '}
        <Route
          path='crafted/galleries/filegallery/*'
          element={
            <SuspensedView>
              <FileGalleryPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/courseskill/*'
          element={
            <SuspensedView>
              <CourseSkillPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/courseresult/*'
          element={
            <SuspensedView>
              <CourseResultPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/coursefinished/*'
          element={
            <SuspensedView>
              <CourseFinishedPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courseskillquestions/courseskillquestion/*'
          element={
            <SuspensedView>
              <CourseSkillQuestionPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/courseresulttype/*'
          element={
            <SuspensedView>
              <CourseResultTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/courseskillfeedback/*'
          element={
            <SuspensedView>
              <CourseSkillFeedbackPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/courseresultcriteria/*'
          element={
            <SuspensedView>
              <CourseResultCriteriaPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/courseschedule/*'
          element={
            <SuspensedView>
              <CourseSchedulePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/publishingoption/*'
          element={
            <SuspensedView>
              <PublishingOptionPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/courses/courserole/*'
          element={
            <SuspensedView>
              <CourseRolePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/guidances/guidancetype/*'
          element={
            <SuspensedView>
              <GuidanceTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/guidances/guidancesubtype/*'
          element={
            <SuspensedView>
              <GuidanceSubTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/guidances/guidanceresulttype/*'
          element={
            <SuspensedView>
              <GuidanceResultTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/accounts/filearea/*'
          element={
            <SuspensedView>
              <FileAreaPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/guidances/guidancereport/*'
          element={
            <SuspensedView>
              <GuidanceReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/files/filereport/*'
          element={
            <SuspensedView>
              <FileReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/employeeunits/employeeunit/*'
          element={
            <SuspensedView>
              <EmployeeUnitPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/fileviews/fileview/*'
          element={
            <SuspensedView>
              <FileViewPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/guidances/guidanceinfo/*'
          element={
            <SuspensedView>
              <GuidanceInfoPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/curricula/curriculumtype/*'
          element={
            <SuspensedView>
              <CurriculumTypePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/curricula/activity/*'
          element={
            <SuspensedView>
              <ActivityPage />
            </SuspensedView>
          }
        />
        {/* zg-generateBlock(((zg-route))) */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
